import Loadable from '@loadable/component';

const SSOLogin = Loadable(async () => import('./components/login'));

const ssoRoutes = {
  '/sso': {
    components: { main: SSOLogin }
  }
};

export default ssoRoutes;
